import Alpine from 'alpinejs';

// Components
//import Choices from 'choices.js';
import "choices.js/public/assets/styles/choices.css";

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

// try {
//     const choices = new Choices('#choices-location');
// } catch (error) {

// }

Fancybox.bind("[data-fancybox]", {
    // Your custom options
});

document.addEventListener('alpine:init', () => {    

    Alpine.data('youtubeEmbed', () => ({
        init() {
            // Find all oembed elements
            const oembedElements = document.querySelectorAll('oembed[url]');

            oembedElements.forEach(element => {
                const url = element.getAttribute('url');
                const videoId = this.extractYouTubeId(url);

                if (videoId) {
                    const iframe = document.createElement('iframe');
                    iframe.setAttribute('src', `https://www.youtube.com/embed/${videoId}`);
                    iframe.setAttribute('width', '560');
                    iframe.setAttribute('height', '315');
                    iframe.setAttribute('frameborder', '0');
                    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
                    iframe.setAttribute('allowfullscreen', 'true');
                    iframe.title = "YouTube video player";
                    iframe.loading = "lazy";
                    iframe.style.aspectRatio = "16/9";
                    iframe.style.width = "100%";
                    iframe.style.display = "block";
                    iframe.style.height = "auto";
                    iframe.style.margin = "1.5rem auto";

                    if (element.parentNode) {
                        element.parentNode.replaceChild(iframe, element);
                    }
                }
            });
        },

        extractYouTubeId(url) {
            if (!url) return null;
            const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
            const matches = url.match(regex);
            return matches ? matches[1] : null;
        }
    }));
});
// Global
window.Alpine = Alpine;

// Inits
Alpine.start();